import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';

export const checkExistsUnrestrictedPlan = async ({
	queryKey,
}): Promise<boolean> => {
	const [, cycleId] = queryKey;

	const response = await api.get('/consensus/exists-by-cycle', {
		params: { cycle_id: cycleId },
	});
	return response.data;
};

export const useExistsUnrestrictedPlan = (cycleId?: number | string) => {
	return useQuery(
		['unrestrictedPlan-exists-byId', cycleId],
		checkExistsUnrestrictedPlan,
		{
			refetchOnWindowFocus: true,
			enabled: !!cycleId,
		}
	);
};
